import { Modal } from "@mui/material";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import {
  Log,
  PassengerDeleteResultEnum,
  ridePassengerDeleteConfirmAtom,
} from "@ryde/shared";

import { ModalContainerStyled, ModalHeaderStyled } from "../controls";
import { PassengerDeleteBody } from "./confirm.passenger-delete.body";
import { MODAL_WIDTH } from "./confirm.passenger-delete.constants";
import { PassengerDeleteFooter } from "./confirm.passenger-delete.footer";

export const ConfirmPassengerDeleteContainer: FC = () => {
  const { t } = useTranslation();
  const [confirmData, setPassengerDeleteData] = useRecoilState(
    ridePassengerDeleteConfirmAtom,
  );

  const onResult = useCallback(
    (result: PassengerDeleteResultEnum) => () => {
      if (!confirmData) {
        Log.warnAndToast(t("errors.INVALID_DELETE_HANDLER_DATA"));
        return;
      }

      confirmData.resolveFn(result);
      Log.debug(
        "Passenger delete handler with result:",
        result,
        confirmData.passengers,
      );
      setPassengerDeleteData(null);
    },
    [confirmData, setPassengerDeleteData, t],
  );

  if (!confirmData) {
    return null;
  }

  return (
    <Modal open={true} closeAfterTransition={true}>
      <ModalContainerStyled width={MODAL_WIDTH}>
        <ModalHeaderStyled>
          <h1>{t(`general.REMOVE_PASSENGERS_TITLE`)}</h1>
          <SVG_MUI.XMarkSVG
            onClick={onResult(PassengerDeleteResultEnum.NoAction)}
          />
        </ModalHeaderStyled>

        <PassengerDeleteBody confirmData={confirmData} />

        <PassengerDeleteFooter confirmData={confirmData} onResult={onResult} />
      </ModalContainerStyled>
    </Modal>
  );
};
